<ng-container *ngFor="let escorted of day.escorteds[0]?.optionals">
  <app-recap-city [day]="escorted" [serviceIcons]="serviceIcons"></app-recap-city>
  <div class="row">
    <div class="col-12 pl-4 pt-2">
      <span class="overview-icons"><app-service-icon [icon]="'bus'" [customPath]="getServiceIconPath('bus')"></app-service-icon></span>
      <span class="text-capitalize">{{ escorted.type?.toLowerCase() }}</span>
      <hr class="line-green mb-1 mx-1">
    </div>
  </div>
</ng-container>